import { Observable } from 'rxjs';
import { BaseController } from '~client/controller/base-controller';
import { AdminLoginRequest } from '~client/model/admin/admin-login-request';
import { AdminLoginResponse } from '~client/model/admin/admin-login-response';
import { ResponseEntity } from '~client/model/response-entity';

/* Admin APIs to login/logout */
export class AdminController extends BaseController {
  /* Allows the admin to login */
  public login$(request: AdminLoginRequest): Observable<AdminLoginResponse> {
    return this.post$('/auth/admin/login', request);
  }

  /* Allows the admin to logout */
  public logout$(): Observable<ResponseEntity> {
    return this.post$('/auth/admin/logout');
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src426716145/src/modules/client/src/controller/admin-controller.ts